export const Routes = {
  // Super Admin Routes
  superAdmin: {
    Dashboard: { path: "/super-admin/dashboard" },
    TagsList: { path: "/super-admin/tags-list" },
    AgencyAdmin: { path: "/super-admin/agency-admin" },
    Agencies: { path: "/super-admin/agencies" },
    UserList: { path: "/super-admin/UsersList" },
    AgenciesDetails: { path: "/super-admin/agencies" }, // Dynamic route for agency details
  },

  // Admin Routes
  admin: {
    Dashboard: { path: "/admin/dashboard" },
    User: { path: "/admin/user" },
    Product: { path: "/admin/Product" },
    User: { path: "/admin/system-User" },
    // Product: { path: "/admin/products-list" },
    CategoryList: { path: "/admin/category-list" },
    Tags: { path: "/admin/tags-list" },
    Categories: { path: "/admin/Categories" },
    ProductAttributes: { path: "/admin/ProductAttributes" },
  },

  // Auth Routes
  Login: { path: "/login" },
  Signup: { path: "/sign-up" },
  ForgotPassword: { path: "/forgot-password" },
  ResetPassword: { path: "/reset-password" },

  // Miscellaneous Routes
  Profile: { path: "/profile" },
  NotFound: { path: "/404" },
  ServerError: { path: "/500" },

  // components
  Accordions: { path: "/components/accordions" },
  Alerts: { path: "/components/alerts" },
  Badges: { path: "/components/badges" },
  Widgets: { path: "/widgets" },
  Breadcrumbs: { path: "/components/breadcrumbs" },
  Buttons: { path: "/components/buttons" },
  Forms: { path: "/components/forms" },
  Modals: { path: "/components/modals" },
  Navs: { path: "/components/navs" },
  Navbars: { path: "/components/navbars" },
  Pagination: { path: "/components/pagination" },
  Popovers: { path: "/components/popovers" },
  Progress: { path: "/components/progress" },
  Tables: { path: "/components/tables" },
  Tabs: { path: "/components/tabs" },
  Tooltips: { path: "/components/tooltips" },
  Toasts: { path: "/components/toasts" },
  WidgetsComponent: { path: "/components/widgets" }
};
